import * as gqlTypes from "@hydrologiq/gql/graphql"
import { useCreateFormData } from "@hydrologiq/shared/contexts/ActivityWorkflowContextV2"
import OrderBanner from "../OrderBanner"

/**
 * OrderContextBanner - A wrapper that displays the OrderBanner for Fulfilment activities
 * during the activity creation workflow.
 *
 * Pulls the order from the workflow context and only renders when:
 * - The activity kind is Fulfilment
 * - An order has been selected
 */
function OrderContextBanner() {
  const createFormData = useCreateFormData()

  // Only render for Fulfilment activities with a selected order
  if (!createFormData || createFormData.kind !== gqlTypes.ActivityKind.Fulfilment || !createFormData.order) {
    return null
  }

  return <OrderBanner order={createFormData.order} />
}

export default OrderContextBanner
